'use client';
import type { Placement } from '@floating-ui/react-dom';
import { useRef } from 'react';

import QuestionMarkIcon from '~public/assets/icons/question-mark.svg';
import { Popover } from '~shared/ui/atoms/Popover';

import { Button, TooltipBox } from './styles';

type Props = {
	children?: React.ReactNode;
	placement?: Placement;
	onClick?: () => void;
	onShow?: () => void;
};

export const TooltipButton = ({
	children,
	placement = 'top-end',
	onClick,
	onShow,
}: Props) => {
	const buttonRef = useRef<HTMLButtonElement>(null);

	return (
		<>
			<Button type="button" ref={buttonRef} onClick={onClick}>
				<QuestionMarkIcon />
			</Button>

			{children && (
				<Popover placement={placement} ref={buttonRef} onShow={onShow}>
					<TooltipBox>{children}</TooltipBox>
				</Popover>
			)}
		</>
	);
};
